import moment from 'moment'
import React, { useMemo } from 'react'

import { EuiDatePicker, EuiDatePickerRange, EuiFlexGroup, EuiFlexItem, EuiLoadingContent, EuiPanel, EuiProgress, EuiSpacer, EuiStat, EuiSuperSelect, EuiText, EuiTitle } from '@elastic/eui'

import { BudgetFrequency, Campaign, CustomerOptimizationType } from 'api/interfaces'
import { CampaignProgress } from 'components/Campaign/CampaignProgress'
import { CampaignStatusToElasticColor, CampaignStatusToString, InsertSpaces } from 'utils/EnumToFriendly'
import { formatCurrency } from 'utils/Formatters'

interface CampaignDetailsProps {
  campaign: Campaign
}

const CampaignDetails: React.FC<CampaignDetailsProps> = ({ campaign }) => {
  const formattedStartDate = useMemo(() => {
    const startDate = campaign.startDate ?? campaign.activated
    return startDate ? moment(startDate).format('MM/DD/yyyy') : 'Not set'
  }, [campaign])

  return (
    <EuiPanel>
      <EuiFlexGroup justifyContent='spaceBetween' alignItems='center'>
        <EuiFlexItem grow={false}>
          <EuiTitle size='m'>
            <h2>Campaign: {campaign.name}</h2>
          </EuiTitle>
        </EuiFlexItem>
      </EuiFlexGroup>

      <EuiSpacer size='xl' />

      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiStat title={formattedStartDate} description='Start Date' titleColor='primary' titleSize='s' />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiStat title={campaign.type} description='Campaign Type' titleColor='primary' titleSize='s' />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiStat title={formatCurrency(campaign.budget)} description={`Budget${campaign.budgetFrequency !== BudgetFrequency.Total ? ` (${campaign.budgetFrequency})` : ''}`} titleColor='primary' titleSize='s' />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiStat title={InsertSpaces(campaign.customerOptimizationStrategy?.optimizationType ?? CustomerOptimizationType.QualityImpressions)} description='Strategy' titleColor='primary' titleSize='s' />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiStat title={CampaignStatusToString(campaign)} description='Delivery' titleColor={CampaignStatusToElasticColor(campaign.status)} titleSize='s' />
        </EuiFlexItem>
      </EuiFlexGroup>

      {campaign.budgetFrequency === BudgetFrequency.Total && (
        <>
          <EuiSpacer size='xl' />
          <CampaignProgress campaign={campaign} size='l' />
          <EuiSpacer size='m' />
        </>
      )}

      {campaign.budgetFrequency !== BudgetFrequency.Total && <EuiSpacer size='m' />}
    </EuiPanel>
  )
}

export default CampaignDetails
